<template>
  <div>
    <div style="padding:0 100px 10px 100px;">{{ title }}</div>
    <div class="code__div">
      <!-- <span class="title__span">
      {{title}}
    </span> -->
      <el-input maxlength='450' v-model="startCode" style="width: 160px" :placeholder="info.placeholder" @change="change">
        <template slot="prepend">起始</template>
      </el-input>
      <div style="
        width: 30px;
        height: 32px;
        margin: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <el-divider></el-divider>
      </div>
      <el-input maxlength='450' v-model="endCode" style="width: 160px" :placeholder="info.placeholder" @change="change">
        <template slot="prepend">结束</template>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeBuild",
  props: {
    title: {
      type: String,
      default: (_) => "title",
    },
    value: {
      type: Object,
      default: (_) => null,
    },
    format: {
      type: String,
      default: (_) => "LPN", // LPN (letters plus numbers) 字母加数字，PN(pure numbers) 纯数字
    },
  },
  data() {
    return {
      startCode: "",
      endCode: "",
    };
  },
  updated() {
    // if (this.value) {
    //   const {startCode = '', endCode = ''} = this.value
    //   this.startCode = startCode
    //   this.endCode = endCode
    // }
  },
  computed: {
    info: function () {
      const _format = this.format;
      return {
        reg: _format === "LPN" ? /[A-Z][0-9]/ : /[0-9][1-9]/,
        placeholder: _format === "LPN" ? "例如: A1" : "例如: 01",
        message:
          _format === "LPN"
            ? "格式错误：首位为字母且必须大写，第二位为数字 0 - 9"
            : "格式错误：必须为两位数字，范围 00 ~ 99",
        tooltip:
          _format === "LPN"
            ? "首位为字母且必须大写，第二位为数字 0 - 9"
            : "必须为两位数字，范围 01 ~ 99",
      };
    },
  },
  methods: {
    change: function (val, key) {
      this.$emit("input", {
        startCode: this.startCode,
        endCode: this.endCode,
      });
    },
    // startChange: function (val, key) {
    //   console.log(this.startCode[0] < this.endCode[0] )
    //   console.log(this.startCode[1] < this.endCode[1] )
    //   if (this.info.reg.test(val)) {
    //     if(this.startCode === this.endCode  || this.startCode[0] > this.endCode[0] || this.startCode[1] > this.endCode[1]) {
    //       this.$message.error('开始位置必须比结束位置大')
    //       setTimeout(_ => {
    //         this[key] = ''
    //       }, 200)
    //     }else  {
    //       this.$emit('input', {
    //         startCode: this.startCode,
    //         endCode: this.endCode,
    //       })
    //     }
    //   } else {
    //     this.$message.error(this.info.message)
    //     setTimeout(_ => {
    //       this[key] = ''
    //     }, 200)
    //   }
    // }
  },
};
</script>

<style scoped>
.code__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 100px;
  position: relative;
  top: 0;
  left: 0;
  margin-bottom: 10px;
}

.title__span {
  /* display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: auto 0;
  font-size: 14px;
  line-height: 32px; */
}
</style>
